import { Box, Card, CardActions, CardContent, Skeleton } from "@mui/material";
import { cardOutline } from "../../Styles/Styles";

const CardSkeleton = () => (
  <Card
    sx={{
      maxWidth: "auto",
      position: "relative",
      mb: 2,
      ...cardOutline,
    }}
  >
    {/* Image placeholder */}
    <Skeleton variant="rectangular" height={180} />

    <CardContent>
      <Box display="flex" justifyContent="space-between" mb={1}>
        <Skeleton variant="rounded" width={80} height={30} />
        <Skeleton variant="circular" width={30} height={30} />
      </Box>

      {/* Title */}
      <Skeleton variant="text" width="80%" height={28} />
      <Skeleton variant="text" width="60%" height={28} />

      {/* Category, Location, Date */}
      <Skeleton variant="text" width="50%" height={20} />
      <Skeleton variant="text" width="40%" height={20} />
      <Skeleton variant="text" width="30%" height={20} />
    </CardContent>

    <CardActions sx={{ pl: 2, mb: 1 }}>
      <Skeleton variant="rounded" width={80} height={36} />
      <Skeleton variant="rounded" width={100} height={36} sx={{ ml: 1 }} />
    </CardActions>
  </Card>
);

export default CardSkeleton;
